import { PropsWithChildren } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Col, Layout, Row } from 'antd';
import clsx from 'clsx';

import { MilesText } from 'components';

import { useRedirect } from 'hooks';

interface ITitledContainerProps {
  title: React.ReactNode;
  backLink?: boolean;
  scrollable?: boolean;
  isFullHeight?: boolean; // for not fix container height and make childrens inside scrollable
  titleExtraNode?: React.ReactNode;
  underTitleNode?: React.ReactNode;
}

export const TitledContainer = ({
  title,
  children,
  backLink,
  scrollable,
  isFullHeight = false,
  titleExtraNode,
  underTitleNode,
}: PropsWithChildren<ITitledContainerProps>) => {
  const handleRedirect = useRedirect();

  return (
    <Layout
      className={clsx(
        (isFullHeight || scrollable) && 'h-full',
        (!isFullHeight && !scrollable) && 'min-h-full',
      )}
    >
      <Row
        align='middle'
        justify='space-between'
        className='px-[16px] min-h-[64px] bg-white'
      >
        <Col>
          <Row align='middle'>
            {backLink && (
              <Button
                type='text'
                icon={<LeftOutlined />}
                onClick={handleRedirect(-1)}
                className='mr-2'
              />
            )}

            {typeof title === 'string'
              ? (
                <MilesText
                  size='xxl'
                  className='font-medium'
                >
                  {title}
                </MilesText>
              )
              : title}
          </Row>
        </Col>

        {titleExtraNode}
      </Row>

      {underTitleNode && (
        <div className='pt-[16px] pb-[16px] px-[16px]'>
          {underTitleNode}
        </div>
      )}

      <Layout
        className={
          clsx(
            'pt-[16px] px-[16px]',
            scrollable && 'block overflow-auto',
            underTitleNode && 'pt-0',
          )
        }
      >
        {children}
      </Layout>
    </Layout>
  );
};
